import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { IUserProfile, IUserSettings } from '../util/DataModelInterface';

export const getUser = async (id: number = 0, name: string = "", force: boolean = false) => {
  let user = storage.getUser();
  if (!user || force) {
    const url = `${getFunctionBaseUrl()}/api/getUser/${id}/${name}/`;
    const response = await rest.get(url);
    user = response;
    if(user?.user_id) {
      storage.setUser(user);
      return user as IUserProfile;
    } else {
      return response;
    }
  }
  return user as IUserProfile;
}

export const addUser = async (user: IUserSettings) => {
  const url = `${getFunctionBaseUrl()}/api/addUser/`;
  const response = await rest.post(url, user);
  // console.log("resp: ", response);
  return response;
}

export const modifyUser = async (user: IUserSettings) => {
  const url = `${getFunctionBaseUrl()}/api/modifyUser/`;
  const response = await rest.post(url, user);
  // console.log("resp: ", response);
  return response;
}

export const archiveUser = async (user: IUserSettings) => {
  const url = `${getFunctionBaseUrl()}/api/archiveUser/`;
  const response = await rest.post(url, user);
  // console.log("resp: ", response);
  return response;
}

// export const getUsers = async (all: boolean = true, archived: boolean = false) => {
//   const url = `${getFunctionBaseUrl()}/api/getUsers/${all}/${archived}/`;
//   const response = await rest.get(url);
//   const users = response?.result?.length > 0 ? response.result : '';
//   return users as IUserProfile[];
// }

export const getAllUsers = async (force: boolean = false) => {
  let users = storage.getUsers();
  if (!users || force) {
    let all = true;
    let archived = false;
    const url = `${getFunctionBaseUrl()}/api/getUsers/${all}/${archived}/`;
    const response = await rest.get(url);
    users = response?.result?.length > 0 ? response.result : '';
    if(users) {
      storage.setUsers(users);
    }
    else {
      return response;
    }
  }
  return users as IUserProfile[];
}

export const saveUser = async (user: IUserProfile) => {
  const url = `${getFunctionBaseUrl()}/api/saveUser/`;
  const response = await rest.post(url, user);
  if(response !== false) storage.setUser(user);
  return response;
}

export const exportUsers = async (data: any) => {
  const url = `${getFunctionBaseUrl()}/api/exportUsersList/`;
  const response = await rest.exporting(url, data);
  return response;
}